// import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
// import { TOKEN_DURATION } from '../../redux/reducers/authReducer';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useSelector(state => state.auth);
  const  dispatch =  useDispatch();

  // Après login, planifie la déconnexion
// setTimeout(() => {
//   dispatch(logoutAdmin()); // ou similaire
// }, TOKEN_DURATION);
  
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" />;
  }
  
  return isAdmin ? children : <Navigate to="/" />;
};

export default AdminRoute;
